import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DCUModel } from 'src/app/models/index';
import { CommonService, SiteService } from 'src/app/services/index';

@Component({
  selector: 'app-dcu-inventory',
  templateUrl: './dcu-inventory.component.html',
  styleUrls: ['./dcu-inventory.component.scss']
})
export class DcuInventoryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayAllSiteID = false;
  selectedSite: string;
  dcuSources: any;
  // meterData: any;
  siteId: string;
  sites: any;
  dcuData: any;
  displayedColumns = ['order', 'dcuID', 'dcuName', 'firmwareVersion'];
  constructor(
    private siteService: SiteService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
      this.getDCUDetails();
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe((data) => {
      this.sites = data;
    });
  }
  getDCUDetails() {
    if (localStorage.getItem('isMultipleSites') === 'true') {
      this.selectedSite = this.siteId;
    }
    this.siteService.getDCUBySiteId(this.selectedSite).subscribe((data) => {
      this.dcuData = [];
      for (let i = 0; i < data.length; i++) {
        const model: DCUModel = data[i];
        model.order = i + 1;
        this.dcuData.push(model);
      }
      this.dcuSources = new MatTableDataSource<DCUModel>(this.dcuData);
      this.dcuSources.paginator = this.paginator;
    });
  }
}
